export default __webpack_public_path__ + "static/media/banner_login_movil.c33b25a5.jpg";